import React, { useMemo } from "react";
import WorkerProfileEditor from "../../screens/worker/WorkerProfileEditor";
import { MockedProvider } from "@apollo/client/testing/react";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildUser, buildWorkerProfile } from "../factories";
import type { Meta, StoryObj } from "@storybook/react";
import { ProfileType, WorkingPermitType } from "../../__generated__/graphql";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";
import { StoryStackNavigatorContainer } from "../display-helpers";

function StoryComponent() {
    const user = useMemo(
        () =>
            buildUser({
                nationality: "FR",
                workerProfile: buildWorkerProfile({
                    swissOrHasPermitAnswer: true,
                    lastWorkPermit: {
                        type: WorkingPermitType.PermitB,
                        validFrom: null,
                        validTo: null,
                    },
                }),
            }),
        [],
    );
    return (
        <MockedProvider mocks={[]}>
            <MockedAuthManager user={user}>
                <MockedProfileSwitcherManager profileType={ProfileType.Worker}>
                    <StoryStackNavigatorContainer>
                        <WorkerProfileEditor />
                    </StoryStackNavigatorContainer>
                </MockedProfileSwitcherManager>
            </MockedAuthManager>
        </MockedProvider>
    );
}

const meta = {
    title: "Screens/Worker profile",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
